import { parsePhoneNumber } from 'libphonenumber-js';

export const formatPhone = (phone: string): string => {
  try {
    return parsePhoneNumber(phone).formatInternational();
  } catch (e) {
    return phone;
  }
};
